<template>
  <div class="content">
    <el-dialog v-bind="$attrs" v-on="$listeners" @open="onOpen" title="详情">
      <el-row :gutter="15">
        <el-form
          ref="detailRef"
          :model="roleInfo"
          :rules="rules"
          size="medium"
          label-width="100px"
        >
          <el-col :span="12">
            <el-form-item label="角色名称" prop="name">
              <el-input
                v-model="roleInfo.name"
                :disabled="true"
                clearable
                :style="{ width: '100%' }"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="角色编码" prop="code">
              <el-input
                v-model="roleInfo.code"
                :disabled="true"
                clearable
                :style="{ width: '100%' }"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="角色描述" prop="description">
              <el-input
                v-model="roleInfo.description"
                :disabled="true"
                clearable
                :style="{ width: '100%' }"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业编号" prop="companyId">
              <el-input
                v-model="roleInfo.companyId"
                :disabled="true"
                clearable
                :style="{ width: '100%' }"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <div slot="footer" v-if="false">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handelConfirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import { getAllSystem } from "@/api/dataModel/appSystem";
export default {
  inheritAttrs: false,
  props: ["data"],
  data() {
    return {
      roleInfo: {
        name: "",
        code: "",
        description: "",
        companyId:""
      },
      otherForm: {
        roleAppSystemRelForm: {
          id: "",
          idList: [],
        },
      },
      allAppList: [],
      rules: {
        role_roleName: [
          {
            required: true,
            message: "名称不能为空",
            trigger: "blur",
          },
        ],
        role_roleCode: [
          {
            required: true,
            message: "编码不能为空",
            trigger: "blur",
          },
        ],
        role_appSystemCode: [
          {
            required: true,
            message: "应用系统编码不能为空",
            trigger: "blur",
          },
        ],
        appSystemName: [
          {
            required: true,
            type: "array",
            message: "请至少选择一个名称",
            trigger: "change",
          },
        ],
      },
      appSystemNameOptions: [],
    };
  },
  computed: {},
  watch: {
    data: {
      deep: true,
      handler(newData) {
        let newValue = {
          ...newData,
        };
        this.roleInfo = newValue;
        this.otherForm = newValue.otherForm;
      },
    },
  },
  created() {
    // this.getAppSystemNameOptions()
  },
  mounted() {},
  methods: {
    getAppSys() {
      // getAllSystem().then((res) => {
      //   if (res.code == 0) {
      //     this.allAppList = res.data;
      //   }
      // });
    },
    onOpen() {},
    onClose() {
      this.$refs["detailRef"].resetFields();
    },
    close() {
      this.$emit("update:visible", false);
    },
    handelConfirm() {},
    getAppSystemNameOptions() {
      // 注意：this.$axios是通过Vue.prototype.$axios = axios挂载产生的
      this.$axios({
        method: "get",
        url: "/api/yys/appSystem/getAll",
      }).then((resp) => {
        let { data } = resp;
        let list = data.data;
        const newOptions = list.map((item) => {
          return {
            value: item["id"],
            label: item["appSystemName"],
          };
        });
        this.appSystemNameOptions = newOptions;
        // this.appSystemNameOptions = data.undefined
      });
    },
  },
};
</script>
<style>
.content {
  background-color: #fff;
  padding: 10px;
}
</style>
